export const modalTexts = {
  close: "Cerrar",
  loading: "Cargando…",
  loadError: "No se pudo cargar. Revisa tu conexión.",
  retry: "Reintentar"
} as const
